import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import t from "styled-components";
import { TypographyTokens as e } from "@vds-tokens/typography";
import { Fonts as o } from "@vds-core/typography";
var i = t.li.withConfig({
  displayName: "PaginationListItem",
  componentId: "VDS__sc-1cb7p3f-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", "; // TODO: Viewport awareness?\n  line-height: ", ";\n  margin-", ": auto;\n  text-align: center;\n"])), o.VerizonNHGeTX, e.fontsize.body[12].value, e.lineheight.body[16].value, function (_ref) {
  var t = _ref.$marginSide;
  return t;
});
export { i as default };